import { configureStore } from "@reduxjs/toolkit";
import authSliceReducer from "./State-Slice/AuthSlice";
import { apiSlice } from "./Api/ApiSlice";

const store = configureStore({
    reducer: {
        auth : authSliceReducer,
        [apiSlice.reducerPath] : apiSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true,
})

export default store;